<mat-form-field class="example-full-width" *ngIf="property.renderType === RenderType.TextBox" style="width:100%"
    [ngStyle]="{'opacity': (disabled) ? '0.5' : '1'}">
    <mat-label>{{property.displayName}}</mat-label>
    <input *ngIf="property.renderType === RenderType.TextBox && property.inputType === InputType.Text" disabled
        type="text" matInput [errorStateMatcher]="matcher" [value]="property.value"
        [placeholder]="property.displayName" />

    <input *ngIf="property.renderType === RenderType.TextBox && property.inputType === InputType.Number" disabled
        type="number" matInput [errorStateMatcher]="matcher" [value]="property.value"
        [placeholder]="property.displayName" />

    <input *ngIf="property.renderType === RenderType.TextBox && property.inputType === InputType.Password" disabled
        type="password" matInput [errorStateMatcher]="matcher" [value]="property.value"
        [placeholder]="property.displayName" />

</mat-form-field>

<mat-form-field *ngIf="property.renderType === RenderType.Dropdown" style="width:100%;">
    <mat-label>{{property.displayName}}</mat-label>
    <mat-select matInput [value]="property.value" (selectionChange)="dropdownUpdate($event)" disabled>
        <mat-option *ngFor="let k of property.renderTypeValues" [value]="k.value">
            {{k.text}}</mat-option>
    </mat-select>
</mat-form-field>

<!-- <div class="row" *ngIf="property.renderType === RenderType.Slider">
        <div class="col-12">
            <mat-label style="display: block;font: 800 14px/20px Roboto;padding:5px" >{{property.displayName}}</mat-label>
            <ngx-slider style="width: 100%;" *ngIf="property.renderType === RenderType.Slider" [(value)]="property.value"[options]="options"></ngx-slider>
        </div>
        
    </div> -->

<mat-label style="display: block;font: 800 14px/20px Roboto; margin-bottom: 10px;"
    *ngIf="property.renderType === RenderType.Slider">{{property.displayName}}</mat-label>
<div style="display: flex;justify-content: center;align-items: center;">
    <ngx-slider *ngIf="property.renderType === RenderType.Slider" style="margin-top:10px;width:90%" [(value)]="property.value"
        [options]="options" [manualRefresh]="manualRefresh"></ngx-slider>
</div>

<mat-checkbox *ngIf="property.renderType === RenderType.Checkbox" matInput color="primary" disabled
    (change)="property.value= $event.checked" [value]="property.value">
    <mat-label>{{property.displayName}}</mat-label>
</mat-checkbox>

<mat-slide-toggle style="padding:5px" *ngIf="property.renderType === RenderType.Toggle" matInput disabled
    [checked]="property.value" (change)="toggleUpdate($event)">{{property.displayName}}</mat-slide-toggle>